import styles from "./BulletPoint.module.css";

interface BulletPointProps {
  text: string;
}

function BulletPoint(props: BulletPointProps) {
  if (!props.text) {
    return null;
  }
  return (
    <div className={styles.line}>
      <div className={styles.checkIcon}>
        <span className="narmi-icon-check" />
      </div>
      <span className="fontColor--primary fontSize--s">{props.text}</span>
    </div>
  );
}

export { BulletPoint };
